import { render, staticRenderFns } from "./DadataAddressSelect.vue?vue&type=template&id=7231f0cc&scoped=true&"
import script from "./DadataAddressSelect.vue?vue&type=script&lang=js&"
export * from "./DadataAddressSelect.vue?vue&type=script&lang=js&"
import style0 from "./DadataAddressSelect.vue?vue&type=style&index=0&id=7231f0cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7231f0cc",
  null
  
)

export default component.exports